<template>
	<span class="whitespace-nowrap" :title="shortAddress">
		<i
			v-if="!copyLoading"
			@click="copy"
			class="copy bi-copy mr-2 text-secondary cursor-pointer"
		></i>
		<i
			v-else
			class="bi-check-circle-fill mr-2 text-secondary text-success"
		></i>
		<a
			v-if="!iconOnly"
			@click="showExplorer"
			class="max-w-full text-ellipsis overflow-hidden inline-block align-sub"
		>
			{{ shortAddress }}
		</a>
	</span>
</template>

<script>
import router from "@/router";
import {useCacheStore} from "@/pinia";

export default {
	name: "AccountAddress",
	props: {
		address: {
			required: true,
		},
		full: {
			type: Boolean,
		},
		names: {
			type: Boolean,
			default() {
				return true;
			},
		},
		token: {
			type: Boolean,
			default() {
				return false;
			},
		},
		wallet: {
			type: Boolean,
			default() {
				return false;
			},
		},
		iconOnly: {
			type: Boolean,
		},
		fallbackName: {
			type: String,
		},
	},
	data() {
		return {
			copyLoading: false,
			explorerChannel: new BroadcastChannel("token:explorer"),
		};
	},
	computed: {
		shortAddress: function () {
			if (this.full) return this.address.toString();

			if (!this.address) return "";

			const stra = this.address.toString();

			if (this.names) {
				if (this.$store.state.wallet.address === stra) return "Me";

				const nMap = this.$store.state.cache.nameMap[stra];
				if (nMap)
					return nMap.name.slice(0, 1).toUpperCase() + nMap.name.slice(1);

				const tn = useCacheStore().getTokenName(this.address)
				if (tn) {
					return tn.name
				}

				const tMap = this.$store.state.cache.tokenMap[stra];
				if (tMap)
					return tMap.name.slice(0, 1).toUpperCase() + tMap.name.slice(1);

				const cMap = this.$store.state.cache.collectionMap[stra];
				if (cMap)
					return cMap.name.slice(0, 1).toUpperCase() + cMap.name.slice(1);

				if (this.fallbackName) return this.fallbackName;
			}

			return `${stra.substr(0, 4)}...${stra.substr(-4)}`;
		},
	},
	methods: {
		async copy(e) {
			e.preventDefault()
			e.stopPropagation()
			this.copyLoading = true;
			await navigator.clipboard.writeText(this.address);
			setTimeout(() => {
				this.copyLoading = false;
			}, 1000);
		},
		showExplorer: function (e) {
			if (this.token) {
				router.push(`/${this.address.toString()}`);
				return;
			}
			if (this.wallet) {
				router.push(`/app/profile/${this.address.toString()}`);
				return;
			}

			window.open(this.link(), "_blank")
			// this.explorerChannel.postMessage(this.address.toString());
		},
		link: function () {
			if (!this.address) return "";

			return `${this.$store.state.settings.explorer}/account/${this.address}?${this.$store.getters["settings/clusterQuery"]}`;
		},
	},
};
</script>

<style scoped>
span a {
	font-family: monospace;
}

.text-theme a,
.text-theme .copy {
	color: rgb(var(--theme500)) !important;
}
</style>
